import { ClassProvider, InjectionToken, Provider, Type, ValueProvider } from '@angular/core';
import { environment } from 'src/environments/environment';

export const INIT_DEV_SERVICES_TOKEN = new InjectionToken<InitDevService>('DEV_SERVICES');
export function initDevServiceProvider(devService: Type<InitDevService>): ClassProvider {
  const provider: ClassProvider = { provide: INIT_DEV_SERVICES_TOKEN, useClass: devService, multi: true };
  return provider;
}

export function initDevServiceProviderWithArgs<T>(devServiceWithArgs: Type<InitDevService>, argsType: Type<T>, args: T): Provider[] {
  const classProvider: ClassProvider = { provide: INIT_DEV_SERVICES_TOKEN, useClass: devServiceWithArgs, multi: true };
  const argsProvider: ValueProvider = { provide: argsType, useValue: args };
  return [classProvider, argsProvider];
}

/**
 * Base class for dev services.  This class should not be instantiated in production.
 * @date 3/13/2023 - 3:44:32 PM
 *
 * @export
 * @abstract
 * @class InitDevService
 * @typedef {InitDevService}
 */
export abstract class InitDevService {
  constructor() {
    this.throwProductionError();
  }

  abstract init(): Promise<void>;

  protected throwProductionError() {
    if (environment.production) {
      throw new Error('InitDevService should not be instantiated in production.');
    }
  }
}
